import PropTypes from 'prop-types';
import Modal from 'components/templates/Modal/Modal';
import * as ALOOMA from 'consts/alooma';
import ModalBodyDeleteAccount from 'components/molecules/ModalBodyDeleteAccount/ModalBodyDeleteAccount';

const ModalDeleteAccount = props => {
  const { closeModal, sourcePage } = props;

  return (
    <Modal
      source={sourcePage}
      aloomaModalType={ALOOMA.MODAL_TYPES.POPUP}
      aloomaModalName={ALOOMA.MODAL_NAMES.DELETE_ACCOUNT}
      onClose={closeModal}
      sendPageView={false}
    >
      <ModalBodyDeleteAccount {...props} />
    </Modal>
  );
};

ModalDeleteAccount.propTypes = {
  closeModal: PropTypes.func.isRequired,
  sourcePage: PropTypes.string.isRequired,
};

export default ModalDeleteAccount;
